import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

export interface Props {
	light?: boolean;
	bold?: boolean;
	small?: boolean;
}

const Label = styled.span<Props>`
	color: ${(props) =>
		props.light ? props.theme.colors.lightText : props.theme.colors.darkText};
	font: ${(props) =>
		props.small ? props.theme.font.defaultSmall : props.theme.font.default};
	text-align: left;
	font-weight: ${(props) => (props.bold ? 'bold' : null)};
	line-height: 1.2;
	margin: 1.6vmin;
`;

export default styled(Label)<PositionAndSizeProps>(PositionAndSizeFromProps);
